import socketio from 'socket.io-client';
import console from 'console';

export default {
    methods: {
        initSocket() {
            if (this.$store.state.user) {
                if (this.$socket) {
                    this.$socket.disconnect();
                    this.$socket = null;
                }
                this.$socket = socketio(process.env.VUE_APP_WS_SERVER + '/client', {transports: ["websocket"]});
                this.$socket.on('connect', () => {
                    this.$socket.emit('authenticate', {token: this.$store.state.token});
                    console.log('Socket connected')
                });
                this.$socket.on('disconnect', () => {
                    console.log('Socket disconnected')
                });
                this.$socket.on('pushWebNotification', (data) => {
                    this.$bus.$emit('pushWebNotification', data);
                });
            }
        },
        closeSocket() {
            if (this.$socket) {
                this.$socket.disconnect();
                this.$socket = null;
            }
        }
    },
    mounted() {
        this.initSocket();
        this.$bus.$on('initSocket', this.initSocket);
        this.$bus.$on('closeSocket', this.closeSocket);
    },
    beforeDestroy() {
        this.closeSocket();
        this.$bus.$off('initSocket');
        this.$bus.$off('closeSocket');
    }
}